import React from 'react';
import { Paper, Typography } from '@mui/material';
import { CustomerNumber } from '../../types';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '../common/Table';

interface CustomerNumbersTableProps {
    title: string;
    numbers: any[];
    limit: number;
    page: number;
    handleChangePage: any;
    handleChangeRowsPerPage: any;
}

const CustomerNumbersTable: React.FC<CustomerNumbersTableProps> = ({ title, numbers }) => {
    return (
        <div id={`customer-${title}-numbers-table-div`} className="mb-5">
            <Typography id={`customer-${title}-numbers-table-title`} className="text-2xl mb-2">
                {`Customer ${title} Numbers`}
            </Typography>
            <Paper>
                {numbers && numbers.length ? (
                    <TableContainer id={`customer-${title}-numbers-table-container`}>
                        <Table aria-label="simple table" size="small">
                            <TableHead id={`customer-${title}-numbers-tablehead`}>
                                <TableRow id={`customer-${title}-numbers-tablehead-row`}>
                                    <TableCell>Number</TableCell>
                                    <TableCell>Owned By</TableCell>
                                    <TableCell>Used By</TableCell>
                                    <TableCell align="right">Minutes remaining</TableCell>
                                    <TableCell>Credit Type</TableCell>
                                    <TableCell>Credit Plan</TableCell>
                                    <TableCell>Credit Limit Type</TableCell>
                                    <TableCell>Credit Group</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody id={`customer-${title}-numbers-table-body`}>
                                {numbers.map((number: CustomerNumber, index: number) => (
                                    <TableRow
                                        id={`customer-${title}-numbers-table-row-${index}`}
                                        key={number.number}
                                    >
                                        <TableCell component="th" scope="row">
                                            {number.number}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {number.ownedByDesc}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {number.usedByDesc}
                                        </TableCell>
                                        <TableCell align="right">
                                            {number.minsOwed > 0
                                                ? -number.minsOwed
                                                : number.minsPaid}
                                        </TableCell>
                                        <TableCell>{number.creditType}</TableCell>
                                        <TableCell>{number.creditPlanName}</TableCell>
                                        <TableCell>{number.minLimitType}</TableCell>
                                        <TableCell>{number.creditGroupName}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <div
                        id={`customer-${title}-numbers-table-div`}
                        className="p-4"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                        }}
                    >
                        {`No ${title} Numbers`}
                    </div>
                )}
            </Paper>
        </div>
    );
};

export default React.memo(CustomerNumbersTable);
